import { render } from "./kaihuUpdate.vue?vue&type=template&id=46f3245b&scoped=true"
import script from "./kaihuUpdate.vue?vue&type=script&lang=js"
export * from "./kaihuUpdate.vue?vue&type=script&lang=js"

import "./kaihuUpdate.vue?vue&type=style&index=0&id=46f3245b&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f3245b"]])

export default __exports__